import React from 'react';
import VideoBox from './components/VideoBox';
import ProgressBox from './components/ProgressBox';
import BubbleCommon, { TipsMapType } from '@op/components/BubbleCommon';
import HoverSortCommonSimple from '@op/components/HoverSortCommonSimple';
import SingleTranslateSelect from '@op/components/FilterBoxCommon/filters/languages/singleLauage';
import { FeedsColumnsFuncResultType } from '../types';

export type CommonVideoProps = {
  formatMessage: any;
  language: string;
  wholeGameInfo: any;
  renderKey?: string | Array<string>;
  navigatePage?: any;
  logBtnId?: string;
  gameInfo: any;
  setLanguage?: any;
  sorts?: any;
  setSorts?: any;
  engagementTipsText?: TipsMapType;
  hasHeaderTranlsate?: boolean;
  hasDetailPage?: boolean;
};

export function commonVideo({
  formatMessage,
  language,
  wholeGameInfo,
  renderKey,
  logBtnId,
  gameInfo,
  setLanguage,
  sorts,
  setSorts,
  engagementTipsText,
  hasHeaderTranlsate = false,
  hasDetailPage,
}: CommonVideoProps): FeedsColumnsFuncResultType {
  const getHeader = (item: { text: string; tips?: TipsMapType }) => {
    if (item.tips)
      return (
        <BubbleCommon tipsMap={item.tips}>
          {formatMessage({ id: 'Engagement' })}
        </BubbleCommon>
      );

    return formatMessage({ id: item.text });
  };

  function getTitleHeader() {
    const text = formatMessage({ id: 'Video (Sort by Date)' });

    if (!hasHeaderTranlsate) {
      return text;
    }

    return (
      <div className="dbo-table-header-reviews">
        <HoverSortCommonSimple
          sort={sorts}
          sortKey="comment_time"
          sortChange={(sortItem?: { by: string; order: 'asc' | 'desc' }) => {
            sortItem && setSorts?.(sortItem);
          }}
        >
          {formatMessage({ id: 'Video (Sort by Date)' })}
        </HoverSortCommonSimple>
        <SingleTranslateSelect
          defaultValue={language}
          onChange={(_key: string, value: string) => {
            setLanguage?.(value);
          }}
        />
      </div>
    );
  }

  const norms: {
    text: string;
    key: string;
    tips?: TipsMapType;
    width?: number;
  }[] = [
    {
      text: 'Views',
      key: 'view',
    },
    {
      text: 'Engagement',
      key: 'engagement',
      tips: engagementTipsText,
    },
    {
      text: 'Likes',
      key: 'tweets_like',
    },
    {
      text: 'Dislike',
      key: 'tweets_unlike',
    },
    {
      text: 'Comments',
      key: 'tweets_reply',
    },
    {
      text: 'Shares',
      key: 'share',
    },
    {
      text: 'Followers/Subscribers',
      key: 'follower_number',
      width: 230,
    },
  ];

  return {
    comment_time: {
      key: 'comment_time',
      header: getTitleHeader(),
      width: 530,
      tableSort: !hasHeaderTranlsate,
      render: (records: any) => (
        <VideoBox
          formatMessage={formatMessage}
          language={language}
          wholeGameInfo={wholeGameInfo}
          keyword={renderKey}
          records={records}
          logBtnId={logBtnId}
          gameInfo={gameInfo}
          hasDetailPage={hasDetailPage}
        />
      ),
    },

    ...norms.reduce((acc, cur) => {
      const { key, width } = cur;
      return {
        ...acc,
        [key]: {
          key,
          header: getHeader(cur),
          tableSort: true,
          width: width || 190,
          render: (cvm: any) => {
            const ratioKey = `${key}_ratio`;
            const maxKey = `max_${key}`;
            const value = cvm[key];
            const precent = cvm[ratioKey];
            const total = cvm[maxKey];
            return (
              <ProgressBox
                count={value}
                total_count={total}
                precent={precent}
              />
            );
          },
        },
      };
    }, {}),
  };
}
